import { ShopFocusHeader, WebViewFocusHeader } from 'shared/components';
import { useIsWebView } from 'shared/providers/isWebView';

const useViewSpecificHeaderComponent = () => {
  const isWebView = useIsWebView();
  // If in WebView mode, we need to use the history 'back' behaviour of the WebViewFocusHeader
  return isWebView ? WebViewFocusHeader : ShopFocusHeader;
};

export default useViewSpecificHeaderComponent;
